import { getValuesFromGroupValue } from 'src/hooks/collection-view/get-values-from-groupvalue';
import { moveBlock } from 'src/redux/managers/block/move';
import { updateBlock } from 'src/redux/managers/block/update';
import { cache } from 'src/redux/store';
import { getDropInfo } from 'src/services/app/hook/use-drop-info';
import { selectedBlocksToIds } from './select-block-util';

export const moveToEmpty = () => {
  const { blocks, ui } = cache;
  const { empty, tocInfo } = getDropInfo() ?? {};
  if (!empty) return;
  const { viewId, collectionId, groupValue, subGroupValue } = empty;
  if (!viewId || !collectionId) return;
  const { selectedBlocks } = ui;
  const collection = blocks[collectionId];
  if (!collection) return;

  const dragToc = tocInfo?.dragToc;
  if (!dragToc && !selectedBlocks.length) return;
  const ids = dragToc ? [dragToc] : selectedBlocksToIds(selectedBlocks);

  const [firstId] = ids;

  const dragBlock = blocks[firstId as string];
  if (!dragBlock) return;
  const dragBlockParentId = dragBlock.parentId;

  // 不在同一个 collection_view 中时
  if (dragBlockParentId !== collectionId) {
    moveBlock(ids, { parentId: collectionId, last: true }, viewId);
  }

  ids.forEach((uuid) => {
    const source = selectedBlocks.find((item) => item.blockId === uuid);

    const newCollectionProperties = getValuesFromGroupValue({
      viewId,
      groupValue,
      subGroupValue,
      blockId: uuid,
      oldGroupValues: source?.groupValues,
    });

    const block = blocks[uuid];
    if (!block) return;

    if (Object.keys(newCollectionProperties).length > 0) {
      updateBlock(uuid, {
        data: {
          segments: newCollectionProperties.title ?? block.data.segments,
          collectionProperties: {
            ...block.data.collectionProperties,
            ...newCollectionProperties,
          },
        },
      });
    }
  });
};
